import * as R from 'ramda';

import generator from 'redux/hor/module';

const {
  reducer,
  fetch,
  fetchSuccess,
  save,
  saveSuccess,
  remove,
} = generator({
  name: 'ProductComposition',
  tableId: 30,
  parseItem: R.evolve({
    ___parent: R.prop('key'),
    custom_элемент_рациона: R.prop('key'),
    custom_относится_к: R.prop('key'),
    custom_продукт: R.prop('key'),
    ___createduser: R.prop('key'),
    ___modifieduser: R.prop('key'),
    custom_значение: val => Math.round(val * 10) / 10,
  }),
});

export {
  fetch,
  fetchSuccess,
  save,
  saveSuccess,
  remove,
};

export {
  getItems,
  getItemsByParent,
  getItemsArrayByParent,
} from 'redux/hor/module/selectors';

export {
  getSumComposition,
  getIsHaveComposition,
} from './selectors';

export default reducer;
